import { render, staticRenderFns } from "./novo_usuario_prefeitura.vue?vue&type=template&id=b3e2d2d4&scoped=true"
import script from "./novo_usuario_prefeitura.vue?vue&type=script&lang=js"
export * from "./novo_usuario_prefeitura.vue?vue&type=script&lang=js"
import style0 from "./novo_usuario_prefeitura.vue?vue&type=style&index=0&id=b3e2d2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e2d2d4",
  null
  
)

export default component.exports